import React from 'react';

const Projects = (props) => {
  return <div>Projects page</div>;
};

export default Projects;
